module.exports = __webpack_public_path__ + "img/individuals-leaflets.bb21708e.jpg";